import qs from 'qs';
import React from 'react';

import type { SearchState } from '../collections/searchStateUrlStorageHelpers';

/**
 * Function to update searchRef from URL query strings.
 */
export const updateSearchRefFromUrl = (searchRef: React.MutableRefObject<SearchState>) => {
  searchRef && (searchRef.current = qs.parse(window.location.search.slice(1)) as SearchState);
};
